export const thumbnailComponentsWhitelist = new Set([
  'MediaBackground',
  'ShortText',
]);

const baseTextWrap = {
  text: '',
  component: 'ShortText',
  textColor: 'blue',
  textTheme: 'text',
  textAlignment: 'fc-text-left',
  paddingTop: '',
  paddingBottom: '',
  elementName: 'p',
};

export const shortTextWrap = (options: Partial<typeof baseTextWrap> = baseTextWrap) => ({
  ...baseTextWrap,
  ...options,
});
